<div class="modal-wrapper" #wrap>
  <div class="modal save-bg-color"  role="dialog"
    id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true">
    <div class="modal-header ">
      <h4 class="modal-title save-bg-color"
        tabindex="0" [id]="modalConfig.modalType+'-header'" #closeBtnHeader>{{modalConfig.header}}</h4>
      <button #closeBtn id="btn-close-modal" class="position-absolute"type="button" (click)="close()" (keyup.enter)="close()">
        <span class="icon icon-cross reflect-modal-close" tabindex="0" aria-hidden="true" [ngClass]="{'save-icon' : saveDataFlag === true}"></span>
        <span class="visually-hidden">close modal</span>
      </button>

    </div>
    <div class="modal-content">
      <span id="msgContent" [innerHTML]="modalConfig.content"></span>
    </div>
    <div class="modal-footer">
      <div class="clear-all sidebyside" #okBtn tabindex="0">
        <div class="row">
          <div class="col-md-12">

          </div>
          <button id="footer-primary" class="col-md-12 btn  btn-primary" 
          type="button" (click)="primaryBtnClickHandler()" *ngIf="modalConfig.footerPrimaryBtnLabel !== ''">{{modalConfig.footerPrimaryBtnLabel}}</button>

          <button id="footer-secondary" class="col-md-12 btn btn-secondary" type="button" (click)="secondaryBtnClickHandler()"
          *ngIf="modalConfig.footerSecondaryBtnLabel !== ''">{{modalConfig.footerSecondaryBtnLabel}}</button>
        </div>
      </div>

      
  </div>
</div>